export const CORPORATE_QA_PREMIUM = 'corporate_qa_premium'
export const EMPLOYMENT_QA_PREMIUM = 'employment_qa_premium'
export const CORPORATE_QA_LITE = 'corporate_qa_lite'
export const CORPORATE_NEWS_PREMIUM = 'corporate_news_premium'
export const EMPLOYMENT_NEWS_PREMIUM = 'employment_news_premium'
export const CORPORATE_NEWS_LITE = 'corporate_news_lite'
export const EMPLOYMENT_NEWS_LITE = 'employment_news_lite'
export const CORPORATE_MARKETS_PREMIUM = 'corporate_markets_premium'
export const EMPLOYMENT_MARKETS_PREMIUM = 'employment_markets_premium'
export const CORPORATE_DOCDRAFTER_PREMIUM = 'corporate_docdrafter_premium'
export const EMPLOYMENT_DOCDRAFTER_PREMIUM = 'employment_docdrafter_premium'
export const CORPORATE_DOCDRAFTER_LITE = 'corporate_docdrafter_lite'
export const EMPLOYMENT_DOCDRAFTER_LITE = 'employment_docdrafter_lite'
